import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PigMenuComponent } from './pig-menu.component';

@NgModule({
  declarations: [PigMenuComponent],
  exports: [PigMenuComponent],
  imports: [CommonModule],
})
export class PigMenuModule {}
